<div class="mini-calendar-panel">
  <div class="mini-calendar">
    <div class="mini-calendar__wrapper">
      <div class="mini-calendar__step">
        <span class="mini-calendar__step__item" *ngFor="let hour of currentCalendar.hourItemsStr">
          <p>{{ hour }}</p>
        </span>
      </div>
      <div class="mini-calendar__bar">
        <span class="mini-calendar__bar__item" *ngFor="let hour of currentCalendar.hourItemsStr"></span>
        <div
          class="mini-calendar__bar__item__indicator bgc-primary-500"
          *ngIf="currentCalendar === todayCalendar"
          [ngStyle]="currentCalendar.indicatorPositionStyle"
        ></div>
      </div>
      <div class="mini-calendar__block">
        <span
          class="mini-calendar__block__item"
          *ngFor="let mark of currentCalendar.calendarMarks"
          [ngClass]="mark.cssClass"
          [ngStyle]="mark.widthStyle"
          matTooltip="{{ mark.reasonStr }}: {{ mark.timeStr }}"
          [matTooltipDisabled]="mark.type === 'available'"
        >
          <!--<md-tooltip md-direction="bottom" md-autohide class="mini-calendar__block__item__event"
        data-ng-if="mark.type !== 'available'">-->
          <!--<span class="mini-calendar__block__item__event__time">{{mark.reasonStr}}: {{mark.timeStr}}</span>-->
          <!--</md-tooltip>-->
        </span>
      </div>
      <button
        mat-icon-button
        class="md-primary btn-cal-toggle"
        *ngIf="currentCalendar === todayCalendar"
        (click)="currentCalendar = tomorrowCalendar"
        matTooltip="{{ 'date.tomorrow' | translate }}"
      >
        <mat-icon color="primary">keyboard_arrow_right</mat-icon>
      </button>
      <button
        mat-icon-button
        class="md-primary btn-cal-toggle btn-cal-toggle-tomorrow"
        *ngIf="currentCalendar === tomorrowCalendar"
        (click)="currentCalendar = todayCalendar"
        matTooltip="{{ 'date.today' | translate }}"
      >
        <mat-icon color="primary">keyboard_arrow_left</mat-icon>
      </button>
    </div>
  </div>
</div>
